import React from 'react';
import './Header.css';
import logoImg from '../assets/HomeTempleLogo.png';

interface HeaderProps {
  logoUrl: string;
  altText: string;
}

const Header: React.FC<HeaderProps> = ({ logoUrl, altText }) => {
  return (
    <header className="header">
      <div className="textbox">
        <h1 className="header-title">Temple Gardening</h1>
        <img src={logoImg} alt={altText} className="header-logo" />
        <h2 className="header-subtitle">Garden Specialists</h2>
        <h3 className="header-subtitle">❈ Residential & Commercial ❈</h3>
        <h5 className="header-service-types">Fremantle, Western Australia</h5>
      </div>
    </header>
  );
};

export default Header;